"use-strict";

class StickyAddCart extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.getHeightAddToCart();
    const btn_minimal = this.querySelector("minimal-button");
    if (btn_minimal) {
      btn_minimal.addEventListener("click", this.toggle.bind(this), false);
    }
  }
  getHeightAddToCart() {
    const _this = this;
    this.main = this.closest(".sec__featured-product");
    if (!this.main) return;
    const primaryBtn = this.main.querySelector(".button-trigger__sticky");
    const footer = document.querySelector(".product-sticky-hide");

    if (!primaryBtn) return;

    var isVisible = true;
    window.addEventListener("scroll", function () {
      var buttonRect = primaryBtn.getBoundingClientRect();
      var viewportHeight = window.innerHeight;
      if (footer) {
        var footerRect = footer.getBoundingClientRect();
        if (footerRect.top < window.innerHeight - 100) {
          _this.classList.remove("show-sticky-cart");
          isVisible = true;
        } else {
          if (
            !isVisible &&
            buttonRect.top < viewportHeight &&
            buttonRect.bottom > 0
          ) {
            isVisible = true;
            _this.classList.remove("show-sticky-cart");
          } else if (isVisible && buttonRect.bottom <= 0) {
            isVisible = false;
            _this.classList.add("show-sticky-cart");
          }
        }
      } else {
        if (
          !isVisible &&
          buttonRect.top < viewportHeight &&
          buttonRect.bottom > 0
        ) {
          isVisible = true;
          _this.classList.remove("show-sticky-cart");
        } else if (isVisible && buttonRect.bottom <= 0) {
          isVisible = false;
          _this.classList.add("show-sticky-cart");
        }
      }
    });
  }
  toggle(e) {
    const target = e.currentTarget;
    target.classList.toggle("opened");
    if (!target) return;
    const parent = target.closest("sticky-add-cart");
    if (!parent) return;
    const content = parent.querySelector(".content--expand");
    slideAnime({
      target: content,
      animeType: "slideToggle",
    });
  }
}
customElements.define("sticky-add-cart", StickyAddCart);
// js for fake sold
class SoldProduct extends HTMLElement {
  constructor() {
    super();
    this.sold = this.dataset.sold;
    this.hours = this.dataset.hours;
    this.message = this.dataset.message;
    this.init();
  }
  init() {
    if (this.message && this.sold && this.hours) {
      var message = "";
      message = this.message
        .replace("{{ sold }}", this.randomSelect(this.sold))
        .replace("{{ hours }}", this.randomSelect(this.hours));
      this.innerHTML += message;
    }
  }

  randomSelect(numbers) {
    const numberArray = numbers.split(",");
    const randomIndex = Math.floor(Math.random() * numberArray.length);
    const randomNumber = numberArray[randomIndex];
    return randomNumber;
  }
}
customElements.define("sold-product", SoldProduct);

// js for live view
class LiveView extends HTMLElement {
  constructor() {
    super();
    this.min = this.dataset.min;
    this.max = this.dataset.max;
    this.interval = this.dataset.interval;
    this.message = this.dataset.message;
    this.init();
  }
  init() {
    if (this.message && this.max && this.min && this.interval) {
      this.handle();
      setInterval(() => {
        this.handle();
      }, this.interval * 1000);
    }
  }

  handle() {
    var message = "";
    message = this.message.replace(
      "[count]",
      this.randomSelect(parseInt(this.min), parseInt(this.max))
    );
    this.innerHTML = message;
  }

  randomSelect(min, max) {
    const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
    return randomNumber;
  }
}
customElements.define("live-view", LiveView);



class CompareRadios extends SwatchInit {
  constructor() {
    super();
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    this.init();
    this.initFunction();
  }

  initFunction() {
    this.querySelectorAll(".product__color-swatches--js").forEach((btn) => {
      btn.addEventListener("click", this.onVariantChange.bind(this), false);
    });
  }

  onVariantChange(e) {
    e.preventDefault();
    const target = e.currentTarget;
    target.classList.toggle("active");
    this.handleWhenSwatchUpdate();
  }

  handleWhenSwatchUpdate() {
    this.updateOptions();
    const arrayItem = this.updateMasterId(this.variantData);
    this.handleMediaCompare(arrayItem);
  }

  handleMediaCompare(arrayItem) {
    if (!arrayItem) return;
    const html = `
            ${arrayItem
              .map((item) => {
                return `
                <div class="compare__items-inner">
                        <img width="300px" height="300px" src="${item.featured_media.preview_image.src}" alt="${item.featured_media.alt}">
                        <p class="mb-0 mt-10 heading-style capitalize">${item.title}</p></div>
                    `;
              })
              .join("")}
        `;
    const compareColorContent = this.closest(".compare-colors__content");
    if (!compareColorContent) return;
    const compareItems = compareColorContent.querySelector(".compare__items");
    if (!compareItems) return;
    compareItems.innerHTML = html;
  }

  updateMasterId(variantData) {
    let arrayItem = [];
    this.options.forEach((option) => {
      const matchingVariant = variantData.find((variant) => {
        return variant.options.includes(option);
      });
      if (matchingVariant) {
        arrayItem.push(matchingVariant);
      }
    });
    return arrayItem;
  }
}
customElements.define("compare-radios", CompareRadios);

class ProductRecommendations extends SlideSection {
  constructor() {
    super();
  }
  init() {
    this.call();
  }
  call() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
          if (recommendations.innerHTML.trim().length === 0) {
            // this.remove();
            this.style.display = "none";
            if (document.querySelector(".product-recommendations-heading")) {
              document
                .querySelector(".product-recommendations-heading")
                .remove();
            }
          }
        })
        .finally(() => {
          if (this.querySelector(".swiper-wrapper")) {
            this.initSlide();
            BlsAnimations.innit();
            BlsLazyloadImg.init();          
          }
          initLazyloadItem();
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("product-recommendations", ProductRecommendations);

// js for live view
class SkeletonPage extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    window.setTimeout(() => {
      this.classList.remove("skeleton");
    }, 1500);
  }
}
customElements.define("skeleton-page", SkeletonPage);

// js for live view
class ProductGrouped extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    var group = this.querySelector('.productGroup[type="application/json"]');
    if (!group) return;
    var variantData = JSON.parse(group.innerText);
    var query = "";
    variantData.forEach((e, key, variantData) => {
      if (!Object.is(variantData.length - 1, key)) {
        query += e + "%20OR%20id:";
      } else {
        query += e;
      }
    });
    var productAjaxURL = "?q=id:" + query + "&section_id=product-grouped";
    fetch(`${window.routes.search_url}${productAjaxURL}`)
      .then((response) => response.text())
      .then(async (responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        this.innerHTML = html.querySelector(".product-group").innerHTML;
      })
      .catch((e) => {
        throw error;
      })
      .finally(() => {
        this.eventProductGroupAction();
      });
  }

  eventProductGroupAction() {
    document
      .querySelectorAll(".product-group-list .product-variant-option")
      .forEach((select) => {
        select.addEventListener(
          "change",
          (event) => {
            var target = event.target;
            var image =
                target.options[target.selectedIndex].getAttribute("data-image"),
              price =
                target.options[target.selectedIndex].getAttribute("data-price"),
              pro_handle = target.getAttribute("data-handle"),
              image =
                target.options[target.selectedIndex].getAttribute("data-image"),
              price =
                target.options[target.selectedIndex].getAttribute("data-price"),
              pro_handle = target.getAttribute("data-handle"),
              compare_price =
                target.options[target.selectedIndex].getAttribute(
                  "data-compare-price"
                );
            var img = target
              .closest(".product-group-list")
              .querySelector(".product-group-item ." + pro_handle + "")
              .querySelector("img");
            if (img) {
              img.removeAttribute("srcset");
              img.setAttribute("src", image);
            }
            const productTarget = target.closest(".product-group-item");
            const bls__price = productTarget.querySelector(
              ".product-item__price .card-product-price"
            );
            if (bls__price) {
              if (!bls__price.querySelector(".compare-price")) {
                var ps = document.createElement("div");
                var sp = document.createElement("span");
                var cp = document.createElement("s");
                cp.classList.add("price-item", "compare-price", "dark-grey");
                sp.appendChild(cp);
                ps.appendChild(sp);
                ps.classList.add("price-regular");
                if (productTarget.querySelector(".card-product-price")) {
                  productTarget
                    .querySelector(".card-product-price")
                    .appendChild(ps);
                }
              }
              const cpp = bls__price.querySelector(".compare-price");

              if (cpp) {
                const numComparePrice = Number(compare_price) || 0;
                const numPrice = Number(price) || 0;
                if (numComparePrice && numComparePrice > numPrice) {
                  // 根据设置决定是否显示货币代码
                  const moneyFormat = themeGlobalVariables.settings.show_currency_code
                    ? themeGlobalVariables.settings.money_with_currency_format
                    : themeGlobalVariables.settings.money_format;
                  const compare_format = Shopify.formatMoney(numComparePrice, moneyFormat || cartStrings.money_format);
                  cpp.setAttribute("data-compare-price", String(numComparePrice));
                  // 使用 requestAnimationFrame 确保属性设置完成后再更新文本
                  requestAnimationFrame(() => {
                    cpp.textContent = compare_format;
                  });
                  if (bls__price.querySelector(".price-regular")) {
                    bls__price
                      .querySelector(".price-regular")
                      .classList.add("primary-color");
                  }
                  if (bls__price.querySelector(".price-regular .price")) {
                    bls__price
                      .querySelector(".price-regular .price")
                      .classList.add("price--special");
                  }
                } else {
                  cpp.innerHTML = "";
                  cpp.removeAttribute("data-compare-price");
                  if (bls__price.querySelector(".price-regular")) {
                    bls__price
                      .querySelector(".price-regular")
                      .classList.remove("primary-color");
                  }
                  if (bls__price.querySelector(".price-regular .price")) {
                    bls__price
                      .querySelector(".price-regular .price")
                      .classList.remove("price--special");
                  }
                  // 当没有折扣时，更新主要价格显示，而不是原价位置
                  if (bls__price.querySelector(".price")) {
                    bls__price.querySelector(
                      ".price"
                    ).innerHTML = Shopify.formatMoney(
                      numPrice,
                      cartStrings.money_format
                    );
                  }
                }
              }
            }
            target.setAttribute("data-price", price);
            target.setAttribute("data-compare-price", compare_price);
          },
          false
        );
      });

    let totalQty = 0;
    const classQty = document.querySelectorAll(
      ".quantity__input-product-group"
    );
    classQty.forEach((input) => {
      let valueQtyDefault = input.value;
      let valueAsDefault = parseFloat(valueQtyDefault);
      if (!isNaN(valueAsDefault)) {
        totalQty += valueAsDefault;
      }
      input.addEventListener("change", () => {
        totalQty = 0;
        classQty.forEach((value) => {
          let valueQty = value.value;
          let valueAsQty = parseFloat(valueQty);
          if (!isNaN(valueAsQty)) {
            totalQty += valueAsQty;
          }
        });
      });
    });
    document.querySelectorAll(".product-group-submit").forEach((button) => {
      button.addEventListener(
        "click",
        (event) => {
          if (totalQty === 0) {
            const content = document.querySelector(
              ".form-infor .add-cart-error"
            );
            const messageErrQty = button.getAttribute("data-add-cart-err-qty");
            handleErrorMessagePopup(messageErrQty);
            if (!content) return;
          } else {
            this.submitProductGroup(event);
          }
        },
        false
      );
    });

    document.querySelectorAll(".product-group-buy-now").forEach((button) => {
      button.addEventListener(
        "click",
        (event) => {
          if (totalQty === 0) {
            const content = document.querySelector(
              ".form-infor .add-cart-error"
            );
            const messageErrQty = button.getAttribute("data-add-cart-err-qty");
            handleErrorMessagePopup(messageErrQty);
            if (!content) return;
          } else {
            this.submitNowProductGroup(event);
          }
        },
        false
      );
    });
  }

  submitNowProductGroup(event) {
    event.preventDefault();
    const form = document.getElementById("form-product-grouped");
    const config = fetchConfig("json");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    const formData = new FormData(form);
    config.body = formData;
    fetch(`${routes.cart_add_url}.js`, config)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        if (parsedState.items) {
          window.location.href = "/checkout";
        } else {
          const content = document.querySelector(".form-infor .add-cart-error");
          if (!content) return;
        }
      })
      .catch((e) => {
        throw e;
      });
  }

  submitProductGroup(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    const form = document.getElementById("form-product-grouped");
    const config = fetchConfig("json");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    let openMiniCart = 0;
    const formData = new FormData(form);
    if (cart) {
      formData.append(
        "sections",
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append("sections_url", window.location.pathname);
    }
    config.body = formData;
    target.classList.add("loading");
    fetch(`${routes.cart_add_url}.js`, config)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        fetch("/cart.json")
          .then((res) => res.json())
          .then((cart) => {
            if (cart.item_count != undefined) {
              document.querySelectorAll(".cart-count").forEach((el) => {
                if (el.classList.contains("cart-count-drawer")) {
                  el.innerHTML = `(${cart.item_count})`;
                } else {
                  el.innerHTML = cart.item_count > 100 ? '~' : cart.item_count;
                }
              });
              if (document.querySelector("header-total-price")) {
                document.querySelector("header-total-price").updateTotal(cart);
              }
              const cart_free_ship = document.querySelector(
                "free-ship-progress-bar"
              );
              if (cart_free_ship) {
                cart_free_ship.init(cart.items_subtotal_price);
              }
            }
          })
          .catch((error) => {
            throw error;
          });
        const parsedState = JSON.parse(state);
        if (parsedState.message) {
          handleErrorMessagePopup(parsedState.description);
          if (!content) return;
        } else {
          parsedState.items.forEach((e) => {
            if (e.quantity > 0) {
              openMiniCart = 1;
            }
          });
          cart.getSectionsToRender().forEach((section) => {
            const elementToReplace = document.getElementById(section.id);
            const html = new DOMParser().parseFromString(
              parsedState.sections[section.id],
              "text/html"
            );
            elementToReplace.innerHTML =
              html.querySelector("#minicart-form").innerHTML;
            const countdown = cart.querySelector(".cart-countdown-time");
            const html_countdown = html.querySelector(".cart-countdown-time");
            if (countdown && html_countdown) {
              countdown.innerHTML = html_countdown.innerHTML;
            }
          });
          cart.cartAction();
        }
      })
      .catch((e) => {
        throw e;
      })
      .finally(() => {
        target.classList.remove("loading");
        if (openMiniCart === 1) {
          cart.open();
        }
        const cartRecommend = document.querySelector(".cart-recommend");
        if (
          cartRecommend &&
          !cartRecommend.classList.contains("hidden-recommend")
        ) {
          if (cartRecommend.classList.contains('cart-recommend-custom')) {
            const cartUpsellItem = document.querySelectorAll('.cart-upsell-item');
            const cartUpsellSlide = document.querySelectorAll('.swiper-cart-upsell .swiper-slide');
            if (cartUpsellItem.length > 0) {
              setTimeout(function () {
                cartRecommend.classList.add("open");
              }, 800);
            } else if (cartUpsellSlide.length === 0){
              cartRecommend.classList.remove('block');
              cartRecommend.classList.add('hidden');
            }
          }else{
            setTimeout(function () {
              cartRecommend.classList.add("open");
            }, 800);
          }
        }
      });
  }
}
customElements.define("product-group", ProductGrouped);

// js for product addons
class ProductAddons extends PopupBase {
  constructor() {
    super();
    this.productPopupDiv = this.querySelector(".product-addons__content");
    this.init();
  }
  init() {
    if (this.productPopupDiv) {
      this.addEventListener("click", this.onClick.bind(this));
    }
  }
  onClick() {
    const html = this.productPopupDiv;
    if (!html) return;
    html.classList.remove("hidden");
    this.initPopup(
      html,
      `<h3 class="title-popup h5 my-0 px-20 px-md-30 py-20 border-bottom">${this.dataset?.textHeader}</h3>`
    );
  }
}
customElements.define("product-addons", ProductAddons);

class SwatchDropdown extends HTMLElement {
  constructor() {
    super();
    this.spanFor = this.dataset.spanFor;
    this.init();
  }
  init() {
    if (!this.spanFor) return;
    this.addEventListener("click", this.activeFilterSort.bind(this), false);
  }
  activeFilterSort() {
    if (this.querySelector(`#${this.spanFor}`).classList.contains("active")) {
      this.querySelector(`#${this.spanFor}`).classList.remove("active");
    } else {
      this.querySelector(`#${this.spanFor}`).classList.add("active");
    }
  }
}
customElements.define("swatch-dropdown", SwatchDropdown);

class ProductBoughtTogether extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    const boughTogether = document.querySelector(
      '.productBoughTogether[type="application/json"]'
    );
    if (!boughTogether) return;
    const variantData = JSON.parse(boughTogether.innerText);
    let query = "";
    variantData.forEach((e, key, variantData) => {
      if (!Object.is(variantData.length - 1, key)) {
        query += e + "%20OR%20id:";
      } else {
        query += e;
      }
    });
    const productAjaxURL =
      "?q=id:" + query + "&section_id=product-bough-together";
    fetch(`${window.routes.search_url}${productAjaxURL}`)
      .then((response) => response.text())
      .then(async (responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        document.getElementById("product-bought-together").innerHTML =
          html.querySelector(".bought-together").innerHTML;
      })
      .catch((e) => {
        throw error;
      })
      .finally(() => {
        this.eventProductBoughTogetherAction();
      });
  }
  eventProductBoughTogetherAction() {
    var _this = this;
    document
      .querySelectorAll(".bought-together-checkbox")
      .forEach((checkbox) => {
        checkbox.addEventListener(
          "change",
          (event) => {
            var target = event.target;
            var total_price = 0,
              total_compare_price = 0,
              save_price = 0,
              price,
              compare_price,
              pro_handle = event.target.getAttribute("data-handle");
            var img = target
              .closest("#product-bought-together")
              .querySelector(".product-bought-image-item." + pro_handle + "");
            if (target.checked) {
              img.classList.add("select");
              target
                .closest(".product-bought-together-item")
                .classList.add("select");
              target
                .closest(".product-bought-together-item")
                .querySelector(".product-variant-option")
                .removeAttribute("disabled");
              target
                .closest(".product-bought-together-item")
                .querySelector(".quantity")
                .removeAttribute("disabled");
            } else {
              img.classList.remove("select");
              target
                .closest(".product-bought-together-item")
                .classList.remove("select");
              target
                .closest(".product-bought-together-item")
                .querySelector(".product-variant-option")
                .setAttribute("disabled", true);
              target
                .closest(".product-bought-together-item")
                .querySelector(".quantity")
                .setAttribute("disabled", true);
            }
            setTimeout(function () {
              var bought_together_select = document.querySelectorAll(
                ".product-bought-together-item.select"
              );
              bought_together_select.forEach((item) => {
                var option = item.querySelector(".product-variant-option");
                price = option.getAttribute("data-price");
                compare_price = option.getAttribute("data-compare-price");
                total_price = total_price + Number(price);
                total_compare_price =
                  total_compare_price + Number(compare_price);
              });
              save_price = total_compare_price - total_price;
              _this.eventProductBoughTogetherUpdatePrice(
                total_price,
                total_compare_price,
                save_price
              );
              if (bought_together_select.length <= 1) {
                document
                  .querySelector(".bought-together-submit")
                  .setAttribute("disabled", true);
              } else {
                document
                  .querySelector(".bought-together-submit")
                  .removeAttribute("disabled");
              }
            }, 50);
          },
          false
        );
      });
    document
      .querySelectorAll("#product-bought-together .product-variant-option")
      .forEach((select) => {
        select.addEventListener(
          "change",
          (event) => {
            var target = event.target;
            var total_price = 0,
              total_compare_price = 0,
              save_price = 0,
              image =
                target.options[target.selectedIndex].getAttribute("data-image"),
              price =
                target.options[target.selectedIndex].getAttribute("data-price"),
              pro_handle = target.getAttribute("data-handle"),
              compare_price =
                target.options[target.selectedIndex].getAttribute(
                  "data-compare-price"
                );
            var img = target
              .closest("#product-bought-together")
              .querySelector(".product-bought-image-item." + pro_handle + "")
              .querySelector("img");
            if (img) {
              img.removeAttribute("srcset");
              img.setAttribute("src", image);
            }
            const productTarget = target.closest(
              ".product-bought-together-item"
            );
            const bls__price = productTarget.querySelector(
              ".product-item__price .card-product-price"
            );
            if (bls__price) {
              if (!bls__price.querySelector(".compare-price")) {
                var ps = document.createElement("div");
                var sp = document.createElement("span");
                var cp = document.createElement("s");
                cp.classList.add("price-item", "compare-price", "dark-grey");
                sp.appendChild(cp);
                ps.appendChild(sp);
                ps.classList.add("price-regular");
                if (productTarget.querySelector(".card-product-price")) {
                  productTarget
                    .querySelector(".card-product-price")
                    .appendChild(ps);
                }
              }
              const cpp = bls__price.querySelector(".compare-price");

              if (cpp) {
                const numComparePrice = Number(compare_price) || 0;
                const numPrice = Number(price) || 0;
                if (numComparePrice && numComparePrice > numPrice) {
                  // 根据设置决定是否显示货币代码
                  const moneyFormat = themeGlobalVariables.settings.show_currency_code
                    ? themeGlobalVariables.settings.money_with_currency_format
                    : themeGlobalVariables.settings.money_format;
                  const compare_format = Shopify.formatMoney(numComparePrice, moneyFormat || cartStrings.money_format);
                  cpp.setAttribute("data-compare-price", String(numComparePrice));
                  // 使用 requestAnimationFrame 确保属性设置完成后再更新文本
                  requestAnimationFrame(() => {
                    cpp.textContent = compare_format;
                  });
                  if (bls__price.querySelector(".price-regular")) {
                    bls__price
                      .querySelector(".price-regular")
                      .classList.add("primary-color");
                  }
                  if (bls__price.querySelector(".price-regular .price")) {
                    bls__price
                      .querySelector(".price-regular .price")
                      .classList.add("price--special");
                  }
                } else {
                  cpp.innerHTML = "";
                  cpp.removeAttribute("data-compare-price");
                  if (bls__price.querySelector(".price-regular")) {
                    bls__price
                      .querySelector(".price-regular")
                      .classList.remove("primary-color");
                  }
                  if (bls__price.querySelector(".price-regular .price")) {
                    bls__price
                      .querySelector(".price-regular .price")
                      .classList.remove("price--special");
                  }
                  // 当没有折扣时，更新主要价格显示，而不是原价位置
                  if (bls__price.querySelector(".price")) {
                    bls__price.querySelector(
                      ".price"
                    ).innerHTML = Shopify.formatMoney(
                      numPrice,
                      cartStrings.money_format
                    );
                  }
                }
              }
            }
            target.setAttribute("data-price", price);
            target.setAttribute("data-compare-price", compare_price);
            document
              .querySelectorAll(".product-bought-together-item.select")
              .forEach((item) => {
                var option = item.querySelector(".product-variant-option");
                price = option.getAttribute("data-price");
                compare_price = option.getAttribute("data-compare-price");
                total_price = total_price + Number(price);
                total_compare_price =
                  total_compare_price + Number(compare_price);
              });
            save_price = total_compare_price - total_price;
            _this.eventProductBoughTogetherUpdatePrice(
              total_price,
              total_compare_price,
              save_price
            );
          },
          false
        );
      });

    document.querySelectorAll(".bought-together-submit").forEach((button) => {
      button.addEventListener(
        "click",
        this.submitBoughtTogether.bind(this),
        false
      );
    });
  }
  submitBoughtTogether(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    const form = document.getElementById("bought-together-form");
    const config = fetchConfig("json");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    const formData = new FormData(form);
    if (cart) {
      formData.append(
        "sections",
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append("sections_url", window.location.pathname);
    }
    config.body = formData;
    target.classList.add("loading");
    fetch(`${routes.cart_add_url}.js`, config)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        fetch("/cart.json")
          .then((res) => res.json())
          .then((cart) => {
            if (cart.item_count != undefined) {
              document.querySelectorAll(".cart-count").forEach((el) => {
                if (el.classList.contains("cart-count-drawer")) {
                  el.innerHTML = `(${cart.item_count})`;
                } else {
                  el.innerHTML = cart.item_count > 100 ? '~' : cart.item_count;
                }
              });
              if (document.querySelector("header-total-price")) {
                document.querySelector("header-total-price").updateTotal(cart);
              }
              const cart_free_ship = document.querySelector(
                "free-ship-progress-bar"
              );
              if (cart_free_ship) {
                cart_free_ship.init(cart.items_subtotal_price);
              }
            }
          })
          .catch((error) => {
            throw error;
          });
        const parsedState = JSON.parse(state);
        cart.getSectionsToRender().forEach((section) => {
          const elementToReplace = document.getElementById(section.id);
          const html = new DOMParser().parseFromString(
            parsedState.sections[section.id],
            "text/html"
          );
          elementToReplace.innerHTML =
            html.querySelector("#minicart-form").innerHTML;
          const countdown = cart.querySelector(".cart-countdown-time");
          const html_countdown = html.querySelector(".cart-countdown-time");
          if (countdown && html_countdown) {
            countdown.innerHTML = html_countdown.innerHTML;
          }
        });
        cart.cartAction();
      })
      .catch((e) => {
        throw e;
      })
      .finally(() => {
        target.classList.remove("loading");
        cart.open();
        const cartRecommend = document.querySelector(".cart-recommend");
        if (
          cartRecommend &&
          !cartRecommend.classList.contains("hidden-recommend")
        ) {
          if (cartRecommend.classList.contains('cart-recommend-custom')) {
            const cartUpsellItem = document.querySelectorAll('.cart-upsell-item');
            const cartUpsellSlide = document.querySelectorAll('.swiper-cart-upsell .swiper-slide');
            if (cartUpsellItem.length > 0) {
              setTimeout(function () {
                cartRecommend.classList.add("open");
              }, 800);
            } else if (cartUpsellSlide.length === 0){
              cartRecommend.classList.remove('block');
              cartRecommend.classList.add('hidden');
            }
          }else{
            setTimeout(function () {
              cartRecommend.classList.add("open");
            }, 800);
          }
        }
      });
  }

  eventProductBoughTogetherUpdatePrice(
    total_price,
    total_compare_price,
    save_price
  ) {
    var total = document.querySelector("#product-bought-together .box-total");
    if (total) {
      total.querySelector(".saved-price .price").innerHTML =
        Shopify.formatMoney(save_price, cartStrings.money_format);
      
      // 只有当原价大于现价时才显示划线价格
      const priceStrikethrough = total.querySelector(".total-price .price__sale .price-item");
      const priceSaleContainer = total.querySelector(".total-price .price__sale");
      
      if (total_compare_price > total_price) {
        if (priceStrikethrough) {
          priceStrikethrough.innerHTML = Shopify.formatMoney(total_compare_price, cartStrings.money_format);
        }
        if (priceSaleContainer) {
          priceSaleContainer.style.display = '';
        }
        total.querySelector(".total-price").classList.add("price--on-sale");
        total
          .querySelector(".total-price .price")
          .classList.add("special-price");
      } else {
        if (priceSaleContainer) {
          priceSaleContainer.style.display = 'none';
        }
        total.querySelector(".total-price").classList.remove("price--on-sale");
        total
          .querySelector(".total-price .price")
          .classList.remove("special-price");
      }
      
      total.querySelector(".total-price .price").innerHTML =
        Shopify.formatMoney(total_price, cartStrings.money_format);
      
      if (save_price > 1) {
        total.querySelector(".saved-price").classList.remove("hidden");
      } else {
        total.querySelector(".saved-price").classList.add("hidden");
      }
    }
  }
}
customElements.define("product-bought-together", ProductBoughtTogether);

document.addEventListener("DOMContentLoaded", function () {
  function addProductEntry(productJson, storedProducts) {
    if (storedProducts === null) storedProducts = [];

    var currentProductID = productJson.id.toString();
    if (!storedProducts.includes(currentProductID)) {
      storedProducts.unshift(currentProductID);
      if (storedProducts.length > 25) {
        storedProducts.pop();
      }
      localStorage.setItem(
        "glozin__recently-viewed-products",
        JSON.stringify(storedProducts)
      );
    } else {
      const index = storedProducts.indexOf(currentProductID);
      if (index > -1) {
        storedProducts.splice(index, 1);
      }
      storedProducts.unshift(currentProductID);
      localStorage.setItem(
        "glozin__recently-viewed-products",
        JSON.stringify(storedProducts)
      );
    }
  }

  const prodData = document.querySelector("[data-product-json]");
  if (prodData != null) {
    var productJson = JSON.parse(prodData.innerHTML);
    var storedProducts = JSON.parse(
      localStorage.getItem("glozin__recently-viewed-products")
    );
    addProductEntry(productJson, storedProducts);
  }
});
var BlsDropDownProduct = (function () {
  return {
    innit: function () {
      var custom_select = document.querySelectorAll(".custom-select");
      if (custom_select) {
        custom_select.forEach((item) => {
          let select__selected = item.querySelector(".select__selected");
          select__selected.addEventListener("click", (e) => {
            let dropdown = e.target.nextElementSibling;
            dropdown.classList.toggle("hidden");
          });
        });
      }
      document.addEventListener("click", function (event) {
        if (!event.target.closest(".custom-select")) {
          document.querySelectorAll(".select__dropdown")?.forEach((item) => {
            item.classList.add("hidden");
          });
        }
      });
    },
  };
})();

BlsDropDownProduct.innit();

var SyncQuantityInput = (() => {
  return {
    init: () => {
      const syncInputs = document.querySelectorAll(
        ".product-detail__buy-buttons input.quantity-input"
      );
      syncInputs.forEach((input) => {
        input.addEventListener("change", function () {
          const value = this.value;
          syncInputs.forEach((otherInput) => {
            if (otherInput !== input) {
              otherInput.value = value;
            }
          });
        });
      });
    },
  };
})();

SyncQuantityInput.init();

class SlideSectionProductSet extends HTMLElement {
  constructor() {
    super();
    this.globalSlide = null;
    this.init();
  }

  init() {
    if (document.body.classList.contains("index")) {
      let pos = window.pageYOffset;
      if (pos > 0 || document.body.classList.contains("swiper-lazy")) {
        this.initSlide();
      } else {
        if (this.classList.contains("lazy-loading-swiper-before")) {
          this.initSlide();
        } else {
          this.classList.add("lazy-loading-swiper-after");
        }
      }
    } else {
      this.initSlide();
    }
  }

  initSlide() {
    const _this = this;
    var autoplaying = _this?.dataset.autoplay === "true";
    const loop = _this?.dataset.loop === "true";
    const itemDesktop = _this?.dataset.desktop ? _this?.dataset.desktop : 4;
    var itemTablet = _this?.dataset.tablet ? _this?.dataset.tablet : "";
    const itemMobile = _this?.dataset.mobile ? _this?.dataset.mobile : 1;
    const direction = _this?.dataset.direction
      ? _this?.dataset.direction
      : "horizontal";
    var autoplaySpeed = _this?.dataset.autoplaySpeed
      ? _this?.dataset.autoplaySpeed * 1000
      : 3000;
    var speed = _this?.dataset.speed ? _this?.dataset.speed : 400;
    const effect = _this?.dataset.effect ? _this?.dataset.effect : "slide";
    const row = _this?.dataset.row ? _this?.dataset.row : 1;
    var spacing = _this?.dataset.spacing ? _this?.dataset.spacing : 30;
    const autoItem = _this?.dataset.itemMobile === "true";
    const arrowCenterimage = _this?.dataset.arrowCenterimage
      ? _this?.dataset.arrowCenterimage
      : 0;
    spacing = Number(spacing);
    autoplaySpeed = Number(autoplaySpeed);
    speed = Number(speed);
    if (autoplaying) {
      autoplaying = { delay: autoplaySpeed };
    }
    if (!itemTablet) {
      if (itemDesktop < 2) {
        itemTablet = 1;
      } else if (itemDesktop < 3) {
        itemTablet = 2;
      } else {
        itemTablet = 3;
      }
    }
    this.globalSlide = new Swiper(_this, {
      slidesPerView: autoItem ? "auto" : itemMobile,
      spaceBetween: spacing >= 15 ? 15 : spacing,
      autoplay: autoplaying,
      direction: direction,
      loop: loop,
      effect: effect,
      speed: speed,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      grid: {
        rows: row,
        fill: "row",
      },
      navigation: {
        nextEl: _this.querySelector(".swiper-button-next"),
        prevEl: _this.querySelector(".swiper-button-prev"),
      },
      pagination: {
        clickable: true,
        el: document.querySelector(".swiper-pagination-product-set"),
        type: "custom",
        renderCustom: function (swiper, current, total) {
          return current + "/" + total;
        }
      },
      breakpoints: {
        768: {
          slidesPerView: itemTablet,
          spaceBetween: spacing >= 30 ? 30 : spacing,
        },
        1025: {
          slidesPerView: itemDesktop,
          spaceBetween: spacing,
        },
      },

      on: {
        init: function () {
          if (arrowCenterimage) {
            var items_slide = _this.querySelectorAll(
              ".product-item__media--ratio"
            );
            if (items_slide.length != 0) {
              var oH = [];
              items_slide.forEach((e) => {
                oH.push(e.offsetHeight / 2);
              });
              var max = Math.max(...oH);
              var arrowsOffset = "--arrows-offset-top: " + max + "px";
              if (_this.querySelectorAll(".swiper-arrow")) {
                _this.querySelectorAll(".swiper-arrow").forEach((arrow) => {
                  arrow.setAttribute("style", arrowsOffset);
                });
              }
            }
          }
        }
      },
    });
  }
}
customElements.define("slide-section-product-set", SlideSectionProductSet);

// 悬浮缩略图功能
window.switchToSlide = function(index) {
  // 获取当前的滑块实例
  const slideWithThumbs = document.querySelector('slide-with-thumbs');
  if (slideWithThumbs) {
    // 尝试使用functionGoto方法
    if (slideWithThumbs.functionGoto) {
      slideWithThumbs.functionGoto(index);
    } else {
      // 备用方案：直接操作swiper实例
      const swiperElement = slideWithThumbs.querySelector('.swiper-wrapper-preview .swiper');
      if (swiperElement && swiperElement.swiper) {
        swiperElement.swiper.slideTo(index);
      }
    }
  }
  
  // 更新激活状态
  updateFloatingThumbnailsActive(index);
}

// Grid布局的切换函数
window.switchToGridSlide = function(index) {
  const galleryViewer = document.querySelector('[id^="GalleryViewer"]');
  if (galleryViewer) {
    const mediaItems = galleryViewer.querySelectorAll('[data-media-id]');
    if (mediaItems[index]) {
      mediaItems[index].scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center' 
      });
    }
  }
  
  // 更新激活状态
  updateFloatingThumbnailsActive(index);
}

// Stack布局的切换函数
window.switchToStackSlide = function(index) {
  const galleryViewer = document.querySelector('[id^="GalleryViewer"]');
  if (galleryViewer) {
    const mediaItems = galleryViewer.querySelectorAll('[data-media-id]');
    if (mediaItems[index]) {
      mediaItems[index].scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center' 
      });
    }
  }
  
  // 更新激活状态
  updateFloatingThumbnailsActive(index);
}

function updateFloatingThumbnailsActive(activeIndex) {
  const thumbnailItems = document.querySelectorAll('.floating-thumbnails .thumbnail-item');
  thumbnailItems.forEach((item, index) => {
    if (index === activeIndex) {
      item.classList.add('active');
    } else {
      item.classList.remove('active');
    }
  });
}

// 初始化悬浮缩略图功能
function initFloatingThumbnails() {
  const slideWithThumbs = document.querySelector('slide-with-thumbs');
  if (!slideWithThumbs) return;
  
  // 监听滑块变化事件
  const mainSwiper = slideWithThumbs.querySelector('.swiper-wrapper-preview .swiper');
  if (mainSwiper && mainSwiper.swiper) {
    // 监听Swiper的slideChange事件
    mainSwiper.swiper.on('slideChange', function() {
      updateFloatingThumbnailsActive(this.activeIndex);
    });
  } else {
    // 备用方案：使用MutationObserver
    const swiperWrapper = slideWithThumbs.querySelector('.swiper-wrapper-preview .swiper-wrapper');
    if (swiperWrapper) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
            // 检查当前激活的slide
            const slides = swiperWrapper.querySelectorAll('.swiper-slide');
            slides.forEach((slide, index) => {
              if (slide.classList.contains('swiper-slide-active')) {
                updateFloatingThumbnailsActive(index);
              }
            });
          }
        });
      });
      
      observer.observe(swiperWrapper, { 
        attributes: true, 
        attributeFilter: ['style'],
        childList: true,
        subtree: true
      });
    }
  }
}

// 监听DOM加载完成和动态内容加载
document.addEventListener('DOMContentLoaded', initFloatingThumbnails);

// 监听AJAX内容加载（如变体切换）
document.addEventListener('variantChange', function() {
  setTimeout(initFloatingThumbnails, 100);
});

// 调试函数 - 检查悬浮缩略图状态
window.debugFloatingThumbnails = function() {
  console.log('🔍 开始调试悬浮缩略图...');
  
  // 检查媒体画廊布局
  const mediaGallery = document.querySelector('media-gallery');
  if (mediaGallery) {
    console.log('📱 媒体画廊布局:', mediaGallery.getAttribute('data-layout'));
  }
  
  // 检查主产品容器
  const mainProduct = document.querySelector('[data-desktop-layout]');
  if (mainProduct) {
    console.log('🖥️ 桌面布局:', mainProduct.getAttribute('data-desktop-layout'));
  }
  
  // 检查悬浮缩略图元素
  const floatingThumbnails = document.querySelector('.floating-thumbnails');
  if (floatingThumbnails) {
    console.log('✅ 悬浮缩略图元素存在');
    const styles = window.getComputedStyle(floatingThumbnails);
    console.log('👁️ 可见性:', {
      opacity: styles.opacity,
      visibility: styles.visibility,
      display: styles.display,
      zIndex: styles.zIndex,
      position: styles.position
    });
    
    // 检查父容器
    const parent = floatingThumbnails.closest('.media-main-swiper');
    if (parent) {
      console.log('📦 父容器存在');
      const parentStyles = window.getComputedStyle(parent);
      console.log('📦 父容器样式:', {
        position: parentStyles.position,
        overflow: parentStyles.overflow
      });
    } else {
      console.log('❌ 找不到父容器 .media-main-swiper');
    }
    
    // 临时显示调试
    floatingThumbnails.classList.add('debug');
    setTimeout(() => {
      floatingThumbnails.classList.remove('debug');
    }, 5000);
  } else {
    console.log('❌ 悬浮缩略图元素不存在');
    
    // 检查可能的原因
    console.log('🔍 检查可能的原因:');
    
    // 检查设置
    const mainProductSection = document.querySelector('[id^="MainProduct"]');
    if (mainProductSection) {
      console.log('⚙️ 主产品section存在');
    }
    
    // 检查所有可能的容器
    const allMediaContainers = document.querySelectorAll('.media-main-swiper, slide-with-thumbs, media-gallery');
    console.log('📋 找到的媒体容器:', allMediaContainers.length);
    allMediaContainers.forEach((container, index) => {
      console.log(`容器 ${index + 1}:`, container.className);
    });
  }
}

// 强制显示悬浮缩略图 - 用于测试
window.forceShowFloatingThumbnails = function() {
  const floatingThumbnails = document.querySelector('.floating-thumbnails');
  if (floatingThumbnails) {
    floatingThumbnails.classList.add('force-show');
    console.log('✅ 强制显示悬浮缩略图');
  } else {
    console.log('❌ 找不到悬浮缩略图元素');
  }
}

// 隐藏强制显示
window.hideFloatingThumbnails = function() {
  const floatingThumbnails = document.querySelector('.floating-thumbnails');
  if (floatingThumbnails) {
    floatingThumbnails.classList.remove('force-show');
    console.log('✅ 隐藏悬浮缩略图');
  }
}

// 创建测试悬浮缩略图 - 用于调试
window.createTestFloatingThumbnails = function() {
  // 移除现有的测试元素
  const existingTest = document.querySelector('.test-floating-thumbnails');
  if (existingTest) {
    existingTest.remove();
  }
  
  // 查找媒体容器
  const mediaContainer = document.querySelector('.media-main-swiper, slide-with-thumbs, media-gallery');
  if (!mediaContainer) {
    console.log('❌ 找不到媒体容器');
    return;
  }
  
  // 创建测试悬浮缩略图
  const testThumbnails = document.createElement('div');
  testThumbnails.className = 'test-floating-thumbnails';
  testThumbnails.style.cssText = `
    position: absolute;
    top: 20px;
    left: 20px;
    z-index: 9999;
    background: rgba(255, 0, 0, 0.9);
    color: white;
    padding: 20px;
    border-radius: 10px;
    font-size: 14px;
    max-width: 300px;
    box-shadow: 0 10px 30px rgba(0,0,0,0.3);
  `;
  
  testThumbnails.innerHTML = `
    <div style="font-weight: bold; margin-bottom: 10px;">🧪 测试悬浮缩略图</div>
    <div>如果您能看到这个红色框，说明悬浮定位正常工作</div>
    <div style="margin-top: 10px;">
      <button onclick="this.parentElement.parentElement.remove()" style="background: white; color: black; border: none; padding: 5px 10px; border-radius: 3px; cursor: pointer;">关闭</button>
    </div>
  `;
  
  // 确保容器有相对定位
  if (getComputedStyle(mediaContainer).position === 'static') {
    mediaContainer.style.position = 'relative';
  }
  
  mediaContainer.appendChild(testThumbnails);
  console.log('✅ 已创建测试悬浮缩略图');
}

// 专门检查hidden_thumbnail模式
window.checkHiddenThumbnailMode = function() {
  const mainProduct = document.querySelector('[data-desktop-layout="hidden_thumbnail"]');
  if (mainProduct) {
    console.log('🎯 检测到hidden_thumbnail模式');
    
    // 查找悬浮缩略图
    const floatingThumbnails = document.querySelector('.floating-thumbnails');
    if (floatingThumbnails) {
      console.log('✅ 悬浮缩略图存在于hidden_thumbnail模式');
    } else {
      console.log('❌ hidden_thumbnail模式下找不到悬浮缩略图');
    }
  } else {
    console.log('ℹ️ 当前不是hidden_thumbnail模式');
  }
}

// 自动检查 - 仅在开发环境启用
// setTimeout(() => {
//   console.log('🔍 检查悬浮缩略图状态...');
//   debugFloatingThumbnails();
//   checkHiddenThumbnailMode();
// }, 2000);

// 添加控制台提示
console.log(`
🛠️ 悬浮缩略图调试工具已加载
可用命令：
- debugFloatingThumbnails() - 检查悬浮缩略图状态
- checkHiddenThumbnailMode() - 检查hidden_thumbnail模式
- forceShowFloatingThumbnails() - 强制显示悬浮缩略图
- createTestFloatingThumbnails() - 创建测试悬浮缩略图
`);

// 产品媒体标签页功能
class ProductMediaTabs {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
    this.initializeActiveTab();
  }

  bindEvents() {
    // 绑定标签页按钮点击事件
    document.addEventListener('click', (e) => {
      if (e.target.closest('.media-tab-btn')) {
        const button = e.target.closest('.media-tab-btn');
        if (!button.classList.contains('disabled')) {
          this.switchTab(button);
        }
      }
    });

    // 键盘导航支持
    document.addEventListener('keydown', (e) => {
      if (e.target.closest('.media-tab-btn')) {
        const buttons = Array.from(document.querySelectorAll('.media-tab-btn:not(.disabled)'));
        const currentIndex = buttons.indexOf(e.target.closest('.media-tab-btn'));
        
        let nextIndex = currentIndex;
        
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          nextIndex = currentIndex > 0 ? currentIndex - 1 : buttons.length - 1;
        } else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          nextIndex = currentIndex < buttons.length - 1 ? currentIndex + 1 : 0;
        } else if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.switchTab(e.target.closest('.media-tab-btn'));
          return;
        }
        
        if (nextIndex !== currentIndex) {
          buttons[nextIndex].focus();
        }
      }
    });
  }

  switchTab(button) {
    const targetTab = button.dataset.tab;
    
    // 更新按钮状态
    document.querySelectorAll('.media-tab-btn').forEach(btn => {
      btn.classList.remove('active');
      btn.setAttribute('aria-selected', 'false');
    });
    
    button.classList.add('active');
    button.setAttribute('aria-selected', 'true');
    
    // 切换内容显示
    document.querySelectorAll('.media-content').forEach(content => {
      content.classList.remove('active');
      content.setAttribute('aria-hidden', 'true');
      // 强制隐藏
      content.style.display = 'none';
      content.style.visibility = 'hidden';
      content.style.opacity = '0';
    });
    
    const targetContent = document.querySelector(`[data-content="${targetTab}"]`);
    if (targetContent) {
      targetContent.classList.add('active');
      targetContent.setAttribute('aria-hidden', 'false');
      // 强制显示
      targetContent.style.display = 'block';
      targetContent.style.visibility = 'visible';
      targetContent.style.opacity = '1';
      
      // 如果是视频内容，暂停其他可能正在播放的视频
      if (targetTab === 'videos') {
        this.pauseOtherVideos(targetContent);
      }
      
      // 触发自定义事件
      document.dispatchEvent(new CustomEvent('mediaTabChanged', {
        detail: { tab: targetTab, content: targetContent }
      }));
      
      console.log(`📱 切换到标签页: ${targetTab}`);
    }
  }

  pauseOtherVideos(currentContent) {
    // 暂停产品主图中的视频
    document.querySelectorAll('.packages-content video').forEach(video => {
      if (video.pause) video.pause();
    });
    
    // 暂停其他标签页中的视频
    document.querySelectorAll('.media-content:not(.active) video').forEach(video => {
      if (video.pause) video.pause();
    });
  }

  initializeActiveTab() {
    // 设置初始的ARIA属性
    document.querySelectorAll('.media-tab-btn').forEach(btn => {
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-selected', btn.classList.contains('active') ? 'true' : 'false');
      btn.setAttribute('tabindex', btn.classList.contains('active') ? '0' : '-1');
    });
    
    document.querySelectorAll('.media-content').forEach(content => {
      content.setAttribute('role', 'tabpanel');
      content.setAttribute('aria-hidden', content.classList.contains('active') ? 'false' : 'true');
    });
    
    // 设置标签页容器的ARIA属性
    const tabContainer = document.querySelector('.media-tabs-container');
    if (tabContainer) {
      tabContainer.setAttribute('role', 'tablist');
      tabContainer.setAttribute('aria-label', '产品媒体标签页');
    }
  }

  // 公共方法：切换到指定标签页
  switchToTab(tabName) {
    const button = document.querySelector(`[data-tab="${tabName}"]`);
    if (button && !button.classList.contains('disabled')) {
      this.switchTab(button);
    }
  }

  // 检查标签页是否可用
  isTabAvailable(tabName) {
    const button = document.querySelector(`[data-tab="${tabName}"]`);
    return button && !button.classList.contains('disabled');
  }
}

// 初始化产品媒体标签页
document.addEventListener('DOMContentLoaded', function() {
  initializeMediaTabs();
});

// 确保在页面加载后也初始化
window.addEventListener('load', function() {
  setTimeout(initializeMediaTabs, 100);
});

function initializeMediaTabs() {
  if (document.querySelector('.media-tabs-container')) {
    window.productMediaTabs = new ProductMediaTabs();
    console.log('📱 产品媒体标签页已初始化');
    
    // 强制确保只有active的内容显示
    setTimeout(() => {
      forceHideInactiveContent();
    }, 50);
  }
}

// 全局辅助函数
window.switchToMediaTab = function(tabName) {
  if (window.productMediaTabs) {
    window.productMediaTabs.switchToTab(tabName);
  } else {
    console.log('❌ 产品媒体标签页未初始化');
  }
};

// 强制隐藏所有非激活的媒体内容
window.forceHideInactiveContent = function() {
  console.log('🔧 强制隐藏非激活的媒体内容...');
  
  document.querySelectorAll('.media-content').forEach((content, index) => {
    const isActive = content.classList.contains('active');
    console.log(`内容 ${index + 1} (${content.dataset.content}): 激活=${isActive}`);
    
    if (!isActive) {
      content.style.display = 'none !important';
      content.style.visibility = 'hidden !important';
      content.style.opacity = '0 !important';
      content.style.position = 'absolute !important';
      content.style.left = '-9999px !important';
    } else {
      content.style.display = 'block';
      content.style.visibility = 'visible';
      content.style.opacity = '1';
      content.style.position = 'relative';
      content.style.left = 'auto';
    }
  });
};

// 调试函数
window.debugMediaTabs = function() {
  console.log('🔍 调试产品媒体标签页...');
  
  const tabContainer = document.querySelector('.media-tabs-container');
  if (tabContainer) {
    console.log('✅ 标签页容器存在');
    
    const buttons = document.querySelectorAll('.media-tab-btn');
    const contents = document.querySelectorAll('.media-content');
    
    console.log(`📊 找到 ${buttons.length} 个标签页按钮`);
    console.log(`📊 找到 ${contents.length} 个内容区域`);
    
    buttons.forEach((btn, index) => {
      const tab = btn.dataset.tab;
      const isActive = btn.classList.contains('active');
      const isDisabled = btn.classList.contains('disabled');
      console.log(`标签页 ${index + 1}: ${tab} - 激活: ${isActive}, 禁用: ${isDisabled}`);
    });
    
    contents.forEach((content, index) => {
      const tab = content.dataset.content;
      const isActive = content.classList.contains('active');
      console.log(`内容区域 ${index + 1}: ${tab} - 激活: ${isActive}`);
    });
    
    if (window.productMediaTabs) {
      console.log('✅ 产品媒体标签页实例存在');
    } else {
      console.log('❌ 产品媒体标签页实例不存在');
    }
  } else {
    console.log('❌ 标签页容器不存在');
  }
};